import { Navigate, useLocation } from 'react-router-dom';

import { ErrorPage } from '@/components/error-page';
import { LostArt } from '@/components/illustrations';

export function NotFoundPage() {
  const { pathname } = useLocation();
  // Kimai prefixed every URL with a locale (/en/homepage, /en/timesheet/) and those
  // are still in people's bookmarks. Drop the prefix and let the router decide.
  const legacy = pathname.match(/^\/[a-z]{2}(?:\/(.*))?$/);
  if (legacy) {
    const rest = (legacy[1] ?? '').replace(/\/$/, '');
    return <Navigate to={rest === 'homepage' ? '/' : `/${rest}`} replace />;
  }
  return (
    <ErrorPage
      code={404}
      art={LostArt}
      title="That page does not exist"
      body="The link may be from an older version of the app, or the page may have moved."
    />
  );
}
